import { render } from "./DuplicateArea.vue?vue&type=template&id=8606114a&scoped=true"
import script from "./DuplicateArea.vue?vue&type=script&lang=js"
export * from "./DuplicateArea.vue?vue&type=script&lang=js"

import "./DuplicateArea.vue?vue&type=style&index=0&id=8606114a&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8606114a"]])

export default __exports__